import React, { useEffect, useState } from 'react';
import { Table, Button, Typography, Row, Col, Progress, Modal } from 'antd';
import { CheckCircleOutlined, ClockCircleOutlined} from '@ant-design/icons';
import { Database } from './supabase-types.ts';
import { green, red } from '@ant-design/colors';
import { SupabaseClient } from '@supabase/supabase-js';

const { Title, Paragraph } = Typography;


type Card = Database['public']['Tables']['card']['Row'];
type Goal = Database['public']['Tables']['goal']['Row'];

export type FullCard = Card & {goal: Goal[]};

const Editor = (props: {supabase: SupabaseClient, goal: Goal, onClose: () => void}) => {
  const {goal, supabase, onClose} = props;
  const isCompleted = (goal.quantity || 1) <= goal.completion_dates.length;

  // Handle the "Complete" button click
  const handleComplete = async () => {

    try {
      const completion_dates = isCompleted ? [] : [...goal.completion_dates, new Date().toISOString().slice(0, 10)];
      // Update the record in the "todos" table
      const { data, error } = await supabase
        .from('goal') // Specify the table name (replace with your table)
        .update({completion_dates})
        .eq('id', goal.id); // Specify the condition to find the record by ID
  
      if (error) {
        throw error;
      }
  
      // Log the updated data (optional)
      console.log('Updated Todo:', data);
      onClose();
    } catch (error) {
      console.error('Error updating record:', error);
    }
  };
  const buttonLabel = isCompleted
  ? 'Undo Completion'
  : (goal.quantity || 1) == 1 ? 'Mark as Completed' : 'Increment Counter'
  const buttonStyle = isCompleted ? 'dashed' : 'primary';
  return (
    <div>
      {/* Modal Dialog */}
      <Modal
        title={goal.title}
        open={true}
        onCancel={onClose}
        footer={null} // Hide the default footer
        width={400} // Optional width adjustment
      >
        {/* Title and Description */}
        <Typography>
          <Paragraph>
            {goal.description}
          </Paragraph>
        </Typography>

        {/* Complete Button */}
        <Button
          type={buttonStyle}
          onClick={handleComplete}
          style={{ width: '100%' }}
        >
          {buttonLabel}
        </Button>
      </Modal>
    </div>
  );
};

function getDifferenceInDays(isoDate: string) {
  const now = new Date(); // Current date and time
  const targetDate = new Date(isoDate); // Convert ISO string to Date object

  // Calculate the difference in milliseconds
  const differenceInMilliseconds = now - targetDate;

  // Convert milliseconds to days (1 day = 24 * 60 * 60 * 1000 ms)
  const differenceInDays = Math.ceil(differenceInMilliseconds / (1000 * 60 * 60 * 24));

  return differenceInDays;
}

const Cell = (goal: Goal) => {
  const quantity = goal.quantity || 1;
  const steps = goal.completion_dates.length;
  const isCompleted = steps  == quantity;
  const percent = 100*steps/quantity;
  const remainingDays = (goal.duration || 0) - (goal.start_date ? getDifferenceInDays(goal.start_date) : 0);
  
  const squares = quantity <= 20 ? quantity : quantity/2;
  const content = <div style={{width: '100%'}}>

    {goal.title}
    { 
    goal.quantity && 
    
    <div style={{position: 'absolute', top: 0, width: '100%', display: "flex", alignItems: "center", gap: "8px"}}>
      <Typography.Text type="secondary">{`${steps}/${quantity} `}</Typography.Text>
      <Progress percent={percent} steps={squares} size={quantity > 6 ? 'small' : 'default'} strokeColor={green[6]} 
      showInfo={false}/>
      </div>
    } 
    { 
    goal.start_date && goal.duration && 
    <div style={{position: 'absolute', top: 0}}>
              <ClockCircleOutlined />
              <Typography.Text type="secondary">
                &nbsp;
                {remainingDays > 0 ? `${remainingDays} days left` : 'Done!'}
              </Typography.Text>

      </div>
    } 
  </div>;

  if (isCompleted) {
    return <div className='criss'>
      <div className='crossed' style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
        {content}
      </div>
    </div>;
  } else {
    return content;
  }
}

const BingoTable = (props: {card: FullCard, supabase: SupabaseClient, onRefresh: () => void}) => {
  const {card, supabase, onRefresh} = props;
  const [selected, setSelected] = useState<Goal | null>(null);
  const N = card.size;
  const width = 700;

  return (
    <div>
      {selected && <Editor supabase={supabase} goal={selected} onClose={() => {
        setSelected(null); onRefresh();
      }}/>}
      <div className="bingo-card" style={{width, gridTemplateColumns: `repeat(${N}, 1fr)`}}>
        {Array.from({ length: card.size }).map((_, rowIndex) => (
          <Row key={rowIndex} justify="center" align="middle" gutter={[4, 4]}>
            {card.goal.slice(rowIndex * N, rowIndex * N + N).map((value, colIndex) => (
              <Col
                key={colIndex}
                className="bingo-cell"
                onClick={() => setSelected(value)}
                style={{
                  width: width/N,

                }}
                span={card.size - 0.2} // Divide evenly into 5 cells
              >
                <Cell {...value}/>
              </Col>
            ))}
          </Row>
        ))}
      </div>
    </div>

  );
};

export default BingoTable;